import { Map } from 'immutable'
import { AnyAction } from 'redux'
import { combineReducers } from 'redux-immutable'
import * as types from '../actions/actionTypes'
import { AppStateType } from '../utils/appStateReduxStore'
import aggregates from './aggregates'
import apolloAuditLogReducer from './apolloAuditLogReducer'
import articleGroupReducer from './articleGroupReducer'
import articlesReducer from './articlesReducer'
import availableDeliveryTimesReducer from './availableDeliveryTimesReducer'
import consignmentEvents from './consignmentEventsReducer'
import context from './context'
import customerCurrencyReducer from './customerCurrencyReducer'
import { drawer } from './drawer'
import { entities } from './entities'
import { feedbackNotifications } from './feedbackNotifications'
import filter from './filterReducer'
import grid from './gridReducer'
import gridSavedIds from './gridSavedIdsReducer'
import hdServicesReducer from './hdServicesReducer'
import httpStatus from './httpStatus'
import importRecipients from './importRecipients'
import { indexesReducer, withIndexes } from './indexes'
import invoicingDataReducer from './invoicingDataReducer'
import invoicingPageReducer from './invoicingPageReducer'
import manageReturnsPageReducer from './manageReturnsPageReducer'
import map from './map'
import { modal } from './modal'
import notifications from './notifications'
import numberSeriesReducer from './numberSeriesReducer'
import optimizingReducer from './optimizingReducer'
import { pageState } from './pageState'
import preAdviceFollowupPageReducer from './preAdviceFollowupPageReducer'
import recurringExecutedDatesReducer from './recurringExecutedDatesReducer'
import searchAddresses from './searchAddresses'
import searchConsignments from './searchConsignments'
import searchUnitCouriers from './searchCourierUsers'
import searchPhraseReducer from './searchPhraseReducer'
import searchReducer from './searchReducer'
import searchUnits from './searchUnits'
import servicesAndVasesTexts from './servicesAndVasesTextsReducer'
import servicesFromMatrixReducer from './servicesFromMatrixReducer'
import servicesReducer from './servicesReducer'
import shdMatrix from './shdMatrixReducer'
import snackbar from './snackbarReducers'
import {
  suggestedUnitsForLocationReducer,
  suggestedUnitsOnDeliveryReducer,
  suggestedUnitsOnPickupReducer
} from './suggestedUnitsReducer'
import unassignedConsignmentEventsReducer from './unassignedConsignmentEventsReducer'
import unresolvedAddresses from './unresolvedAddressReducer'
import user from './user'
import { websocket } from './websockets'

// Reducers map (cast to any for type simplification – accepted tradeoff)
const reducersObject = {
  articlesReducer,
  user,
  httpStatus,
  pageState,
  availableDeliveryTimesReducer,
  modal,
  entities,
  notifications,
  feedbackNotifications,
  aggregates,
  searchReducer,
  searchConsignments,
  searchAddresses,
  map,
  optimizingReducer,
  websocket,
  drawer,
  servicesFromOptimus: servicesReducer,
  hdServicesReducer,
  servicesFromMatrix: servicesFromMatrixReducer,
  numberSeriesReducer,
  invoicingDataReducer,
  invoicingPageReducer,
  manageReturnsPageReducer,
  preAdviceFollowupPageReducer,
  snackbar,
  grid,
  filter,
  recurringExecutedDatesReducer,
  importRecipients,
  unresolvedAddresses,
  servicesAndVasesTexts,
  context,
  searchUnitCouriers,
  searchUnits,
  searchPhraseReducer,
  suggestedUnitsForLocationReducer,
  suggestedUnitsOnDeliveryReducer,
  suggestedUnitsOnPickupReducer,
  gridSavedIds,
  consignmentEvents,
  shdMatrix,
  apolloAuditLogReducer,
  articleGroupReducer,
  customerCurrencyReducer,
  unassignedConsignmentEventsReducer,
  indexes: indexesReducer
}

const combined = combineReducers(reducersObject as any)

export const rootReducer = (state: AppStateType | undefined, action: AnyAction): AppStateType => {
  if (action.type === types.LOGOUT.SUCCESS) {
    state = Map() as any
  }
  // withIndexes needs entity state both before and after the action to compute the next indexes correctly
  return withIndexes(state, combined(state as any, action) as AppStateType, action)
}

export default rootReducer
